var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHyperspace = function SvgHyperspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 113"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 56.5,
    r: 56.5,
    fill: "#3D69F7"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.691 24H42.135L29.652 50.666c-3.383 7.226-5.074 10.84-4.562 13.6.451 2.427 2.06 4.401 4.596 5.638 2.883 1.407 7.52 1.407 16.792 1.407h12.141l5.235-11.183c.282-.602.423-.903.38-1.133-.037-.203-.172-.367-.383-.47-.24-.117-.626-.117-1.4-.117H51.415c-3.09 0-4.636 0-5.597-.47-.845-.411-1.382-1.07-1.532-1.879-.17-.92.393-2.124 1.52-4.533L58.692 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.803 89.503h16.556l12.483-26.665c3.383-7.227 5.075-10.84 4.562-13.6-.45-2.428-2.06-4.402-4.596-5.639-2.883-1.406-7.52-1.406-16.792-1.406H53.875L48.64 53.375c-.282.603-.423.904-.38 1.134.038.202.172.367.383.47.24.117.627.117 1.4.117H61.08c3.09 0 4.636 0 5.597.469.846.412 1.382 1.07 1.532 1.88.171.92-.393 2.124-1.52 4.532L53.803 89.503Z"
  })))));
};
export default SvgHyperspace;